import { render, staticRenderFns } from "./fenxiao_bill.vue?vue&type=template&id=fbb1f6f4&scoped=true"
import script from "./fenxiao_bill.vue?vue&type=script&lang=js"
export * from "./fenxiao_bill.vue?vue&type=script&lang=js"
import style0 from "./fenxiao_bill.vue?vue&type=style&index=0&id=fbb1f6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb1f6f4",
  null
  
)

export default component.exports